import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'app/shared/config.service';

@Component({
  moduleId: module.id,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  username: string;
  apiUrl: string;

  constructor(private _configService: ConfigService, private _router: Router, private _httpClient: HttpClient) 
  { 
    this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
  }

  ngOnInit() {
    this._showUsername();
  }

  private _showUsername(): void
  {
    if("username" in sessionStorage)
    {
      this.username = sessionStorage.getItem("username");
    }
    else
    {
      this._httpClient.get(`${this.apiUrl}/api/Admin/GetUsername`).subscribe((username: string) => {
        this.username = username;
        sessionStorage.setItem("username", username);
      });
    }
  }

  logout(): void
  {
    sessionStorage.clear();
    this._router.navigateByUrl("/login/admin");
  }


}
